<template>
  <div>
    <img src="../../assets/anniversary/error.png" width="100%" style="margin-top: 20%;">
    <div style="color: #190F90;width: 100%;text-align: center;font-size: 20px;">
      <div>非常抱歉！您未在现场参会人员名单中~ </div>
      <div>如有问题请联系扶巧俐 <a href="tel:18318849909">18318849909</a></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style>
#app {
  background-color: white !important;
}
</style>
